import { useQuery } from '@tanstack/react-query';
import { flowsService } from '../services/flows.service';
import { trafficSourcesService } from '../services/traffic-sources.service';
import { trafficSourceVarNames } from '../utils/tracking-helpers';

const V_SLOT = /^v([1-9]|10)$/;

/** V-slot names from whichever ancestor identifies a source. An empty chain skips it. */
export function useDrilldownVarNames(
  chain: Record<string, unknown>,
  childGroupBy: string,
): Record<string, string> {
  const needed = V_SLOT.test(childGroupBy);
  // A filter can hold several values; only one identifies a source.
  const one = (v: unknown) => (typeof v === 'string' && v ? v : '');
  const directTs = one(chain.traffic_source_id);
  const flowId = one(chain.flow_id);

  const { data: flow } = useQuery({
    queryKey: ['drilldown-flow-ts', flowId],
    queryFn: () => flowsService.getById(flowId),
    enabled: needed && !directTs && !!flowId,
    staleTime: 5 * 60_000,
  });

  const tsId = directTs || (flow?.traffic_source_id ?? '');
  const { data: ts } = useQuery({
    queryKey: ['drilldown-ts-vnames', tsId],
    queryFn: () => trafficSourcesService.getById(tsId),
    enabled: needed && !!tsId,
    staleTime: 5 * 60_000,
  });

  return trafficSourceVarNames(ts || null);
}
